var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Poptip', {
    attrs: {
      "placement": "bottom",
      "transfer-class-name": "download-center-container",
      "trigger": "hover",
      "transfer": "",
      "content": $t("afriiw4", "下载中心")
    }
  }, [_c('div', {
    staticClass: "flex items-center justify-center cursor-pointer w-[32px] h-[32px] rounded-lg transition-colors duration-150 text-[var(--on-surface-variant,#5f5f5f)] hover:bg-stone-100 hover:text-[var(--on-surface,#323233)]"
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-[18px]"
  }, [_vm._v("download")])]), _c('section', {
    staticClass: "w-[320px] text-[#515a6e] bg-white rounded-lg shadow-lg overflow-hidden border border-[#e9ecef]",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('header', {
    staticClass: "text-center flex flex-col gap-4 p-4 bg-gradient-to-b from-[#f8f9fa] to-[#ffffff] border-b border-[#e9ecef] rounded-t-lg"
  }, [_c('div', {
    staticClass: "text-[16px] font-bold whitespace-normal text-[#2c3e50]"
  }, [_vm._v(` ${$t("7816vcg", "下载手机APP，随时关注业务动态")} `)]), _c('span', {
    staticClass: "text-center tip whitespace-normal text-[#6c757d] text-[14px] leading-relaxed"
  }, [_vm._v(` ${$t("290spgh", "使用手机浏览器扫码下载【数智助手】")} `)])]), _c('main', {
    staticClass: "qr_code flex justify-center items-center flex-col p-4"
  }, [_vm._l(_vm.downCenterLinkList, function (item) {
    return [_c('downLoad-item', {
      key: item.name,
      staticClass: "download-item-hover",
      attrs: {
        "item": item
      }
    })];
  })], 2), _c('footer', [_c('a', {
    staticClass: "flex bg-gradient-to-r from-[#f8f9fa] to-[#e9ecef] gap-4 items-center justify-between px-4 py-3 from-[#e9ecef] to-[#dee2e6] transition-all duration-300",
    attrs: {
      "href": "https://app.ihotel.cn/#/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "rounded-lg shadow-sm",
    attrs: {
      "src": require("@/assets/download/download.webp"),
      "alt": "Android",
      "width": "40"
    }
  }), _c('div', {
    staticClass: "flex flex-col justify-center flex-1 min-w-0"
  }, [_c('p', {
    staticClass: "text-[16px] font-bold text-[#2c3e50]"
  }, [_vm._v($t("afriiw4", "下载中心"))]), _c('p', {
    staticClass: "download-center-description text-[#6c757d] whitespace-normal break-words leading-5"
  }, [_vm._v(` ${$t("q1s8j69", "更多应用请点击前往")} `)])]), _c('Icon', {
    staticClass: "text-[#6c757d]",
    attrs: {
      "type": "ios-arrow-forward",
      "size": "20"
    }
  })], 1)])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };